export default __webpack_public_path__ + "static/Czubowicz-a4256d97c86e442f59e31866a5124b78.jpeg";